module.exports = __webpack_public_path__ + "static/img/s10.94bbe812.png";